import useIdentity from '@/components/SiteIdentity'

export default defineNuxtRouteMiddleware(async (to) => {
  const authToken = (to.query.auth_token || to.query.sessionKey) as string | undefined

  if (authToken) {
    const siteIdentity = useIdentity()

    try {
      await siteIdentity.authenticate(authToken)
      await siteIdentity.synchronizeAuthAndIdent(true, false)

      if (import.meta.client) {
        return navigateTo(to.path, {
          replace: true
        })
      }
    } catch (error) {
      console.error('Authentication failed:', error)
    }
  }
})